module.exports = __webpack_public_path__ + "static/media/RPR 1b.aabf3908.jpg";